import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';

// The header's own "Forums" dropdown + "Accueil" link (see addForumsMenu.js)
// already cover browsing by category and getting back to "all discussions",
// so the sidebar's own nav dropdown underneath "Nouvelle discussion"
// (core's default is just "Toutes les discussions", but flarum-tags also
// adds its own tag list to it) is redundant here - only the "Nouvelle
// discussion" button stays.
export default function removeSidebarNav() {
  extend(IndexSidebar.prototype, 'items', function (items) {
    items.remove('nav');
  });
}